import { Input } from "@/components/ui/input";

interface SurchargeFieldProps {
  value: number;
  onChange: (value: number) => void;
}

export const SurchargeField = ({ value, onChange }: SurchargeFieldProps) => {
  return (
    <div className="space-y-2">
      <label
        htmlFor="surcharge"
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        Recargo (%) (opcional)
      </label>
      <div className="relative">
        <Input
          type="number"
          id="surcharge"
          name="surcharge"
          value={value || ""}
          onChange={(e) => {
            const n = Number(e.target.value);
            if (Number.isNaN(n)) return onChange(0);
            const clamped = Math.max(0, Math.min(100, n));
            onChange(clamped);
          }}
          placeholder="0"
          min="0"
          max="100"
          step="1"
          className="w-full pr-8"
        />
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
          %
        </span>
      </div>
    </div>
  );
};
